export const experienceData = [
    {
        "id": 1,
        "companyName": "@VIT, Mumbai",
        "role": "Web Developer Intern",
        "logo": require('../assets/companylogo/vit.png'),
        "duration": "Mar 2023 - present",
        "color": "#FECDD3",
        "color2": "#881337"
    },
    {
        "id": 2,
        "companyName": "@KidsGalaxy",
        "role": "Web Developer Intern",
        "logo": require('../assets/companylogo/kidsgalaxy.png'),
        "duration": "Jan 2023 - Apr 2023",
        "color": "#A5F3FC",
        "color2": "#174F64"
    },
    {
        "id": 3,
        "companyName": "@hacktoberfest",
        "role": "contributor",
        "logo": require('../assets/companylogo/hacktiberfest.jpg'),
        "duration": "Oct 2023 - Oct 2023",
        "color": "#FDE68A",
        "color2": "#78350F"
    },    
]
